module.exports = __webpack_public_path__ + "b792be09105099459ad86b6e5641a93b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/navigation/icon-settings@2x.png
// module id = 780
// module chunks = 0